import { useState, useEffect } from 'react';
import { getAllBlogs } from '../api/blogs';
import { getAllUsers } from '../api/user';
import { useAuth } from '../context/AuthProvider';

// Tableau de bord admin — données réelles depuis le backend
function AdminDashboard() {
    const { token } = useAuth();
    const [blogs, setBlogs] = useState([]);
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Charger les blogs et les utilisateurs en parallèle
        const fetchData = async () => {
            try {
                const blogsData = await getAllBlogs();
                setBlogs(blogsData);
            } catch (err) {
                setBlogs([]);
            }
            try {
                const usersData = await getAllUsers(token);
                setUsers(usersData);
            } catch (err) {
                setUsers([]);
            }
            setLoading(false);
        };
        fetchData();
    }, [token]);

    return (
        <div className="max-w-6xl mx-auto px-8 py-16">
            <h1 className="text-4xl font-bold mb-10">Admin Dashboard</h1>

            {/* Créer un blog */}
            <section className="bg-gray-900 border border-gray-800 rounded-xl p-8 mb-10">
                <h2 className="text-2xl font-bold mb-6">Create New Blog Post</h2>
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm text-gray-400 mb-2">Title</label>
                        <input type="text" placeholder="Blog post title" className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white focus:border-blue-500 outline-none" />
                    </div>
                    <div>
                        <label className="block text-sm text-gray-400 mb-2">Content</label>
                        <textarea rows="6" placeholder="Write your blog post..." className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white focus:border-blue-500 outline-none resize-none"></textarea>
                    </div>
                    <button className="bg-blue-600 hover:bg-blue-500 text-white px-6 py-3 rounded-lg font-semibold">Publish Post</button>
                </div>
            </section>

            {/* Gérer les blogs — données réelles */}
            <section className="bg-gray-900 border border-gray-800 rounded-xl p-8 mb-10">
                <h2 className="text-2xl font-bold mb-6">Manage Blog Posts</h2>
                {loading ? (
                    <p className="text-gray-400">Chargement...</p>
                ) : blogs.length === 0 ? (
                    <p className="text-gray-500">Aucun blog pour le moment.</p>
                ) : (
                    <div className="space-y-4">
                        {blogs.map(blog => (
                            <div key={blog.id} className="flex justify-between items-center bg-gray-800 rounded-lg p-4">
                                <div>
                                    <h3 className="font-semibold">{blog.title}</h3>
                                    <p className="text-sm text-gray-500">{new Date(blog.created_at).toLocaleDateString()}</p>
                                </div>
                                <div className="flex gap-2">
                                    <button className="bg-yellow-600 hover:bg-yellow-500 text-white px-4 py-2 rounded-lg text-sm">Edit</button>
                                    <button className="bg-red-600 hover:bg-red-500 text-white px-4 py-2 rounded-lg text-sm">Delete</button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </section>

            {/* Gérer les utilisateurs — données réelles */}
            <section className="bg-gray-900 border border-gray-800 rounded-xl p-8">
                <h2 className="text-2xl font-bold mb-6">Users</h2>
                {loading ? (
                    <p className="text-gray-400">Chargement...</p>
                ) : users.length === 0 ? (
                    <p className="text-gray-500">Aucun utilisateur pour le moment.</p>
                ) : (
                    <div className="space-y-4">
                        {users.map(user => (
                            <div key={user.id} className="flex justify-between items-center bg-gray-800 rounded-lg p-4">
                                <div>
                                    <h3 className="font-semibold">{user.name}</h3>
                                    <p className="text-sm text-gray-500">{user.email}</p>
                                </div>
                                <span className="text-sm text-gray-500">{user.role}</span>
                            </div>
                        ))}
                    </div>
                )}
            </section>
        </div>
    );
}

export default AdminDashboard;